import React from "react";
import { AppBar, makeStyles, Toolbar } from "@material-ui/core";
import NavBarElements from "./NavBarElements";
import { Link } from "react-router-dom";
import withWidth, { isWidthUp } from "@material-ui/core/withWidth";
import { COMPANY_NAME } from "../../config/constants";
import CustomImage from "../../components/CustomImage";

const useStyles = makeStyles((theme) => ({
  appbar: {
    backgroundColor: theme.palette.background.paper,
  },
  smallToolbar: {
    paddingLeft: 32,
    paddingRight: 32,
    justifyContent: "space-between",
    paddingTop: 30,
    paddingBottom: 20,
  },
  smallLogo: {
    height: 30,
    objectFit: "contain",
  },
  largeToolbar: {
    paddingLeft: "8%",
    paddingRight: "8%",
    justifyContent: "space-between",
    paddingTop: 20,
    paddingBottom: 10,
  },
  largeLogo: {
    height: 40,
    objectFit: "contain",
  },
}));

function NavBar({ children, width, handleLogout }) {
  const classes = useStyles();

  return (
    <React.Fragment>
      <AppBar elevation={0} className={classes.appbar}>
        <Toolbar
          className={
            isWidthUp("lg", width) ? classes.largeToolbar : classes.smallToolbar
          }
        >
          <Link to="/">
            <CustomImage
              alt={COMPANY_NAME}
              src={`${process.env.PUBLIC_URL}/assets/icons/full_logo.png`}
              className={
                isWidthUp("lg", width) ? classes.largeLogo : classes.smallLogo
              }
            />
          </Link>
          <NavBarElements handleLogout={handleLogout} />
        </Toolbar>
      </AppBar>
      <Toolbar />
      {children}
    </React.Fragment>
  );
}

export default withWidth()(NavBar);
